import { keyframes } from '@stitches/react';
import { styled } from '../../styles/index';

const spin = keyframes({
  from: { transform: 'rotate(0deg)' },
  to: { transform: 'rotate(360deg)' },
});

export const LoadingContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,

  variants: {
    inline: {
      false: {
        position: 'fixed',
      },
    },
  },
});

export const LoadingBackground = styled('div', {
  backgroundColor: '$neutralVeryDark',
  opacity: 0.7,
  position: 'absolute',
  width: '100%',
  height: '100%',
  zIndex: 1,
});

export const LoadingCard = styled('div', {
  zIndex: 2,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '$primaryDefault',
  maxWidth: '98px',
  maxHeight: '98px',
  padding: '16px',
  borderBottomLeftRadius: '24px',
  borderTopRightRadius: '24px',
  '& > p': {
    display: 'none',
  },
  '@deviceLarge': {
    maxWidth: '119px',
    maxHeight: '130px',
    '& > p': {
      display: 'block',
    },
  },
});

export const Spin = styled('div', {
  animation: `${spin} 1s linear infinite`,
  transformOrigin: 'center center',
  height: '100px',
  width: '100px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
